import FocusBearLogoAnimated from 'assets/icons/FocusBearLogoAnimated';
import LoadingIndicator from 'components/common/LoadingIndicator';
import React from 'react';
import { t } from 'services/i18n.service';

const OnboardingWelcome = () => {
  return (
    <div className='w-full h-full flex flex-col items-center justify-center ~gap-6/12 ~px-4/8'>
      <FocusBearLogoAnimated className='~w-16/32 ~h-16/32' />
      <div className='w-fit h-fit flex items-start sm:items-center ~gap-2/4'>
        <LoadingIndicator dims='~min-w-5/9 ~min-h-5/9 relative top-1 sm:top-0' />
        <h1 className='~text-base/4xl animate-fadeIn'>
          {t('auth_page.welcome_aboard_preparing_your_account')}
        </h1>
      </div>
    </div>
  );
};

export default OnboardingWelcome;
